import {
  descriptionUI,
  radioUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { PensionDescription } from '../../../components/FormDescriptions';
import content from '../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../utils/imports';

const TITLE_TEXT = content['benefits--pension-title'];
const DESC_TEXT = content['benefits--pension-description'];
const INPUT_LABEL = content['benefits--pension-label'];

const SCHEMA_LABELS = {
  Yes: content['form--default-yes-label'],
  No: content['form--default-no-label'],
};

const { vaPensionType } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT, DESC_TEXT),
    ...descriptionUI(PensionDescription),
    vaPensionType: radioUI({
      title: INPUT_LABEL,
      labels: SCHEMA_LABELS,
    }),
  },
  schema: {
    type: 'object',
    required: ['vaPensionType'],
    properties: {
      vaPensionType,
    },
  },
};
